import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';
import { format } from 'date-fns';
import React from 'react';
import { getStatusInfo } from '../utils/certificateStatusUtils';

const PTPRCertificateVerification = ({ certificate }) => {
   const isExpired = certificate.expiryDate ? new Date(parseInt(certificate.expiryDate)) < new Date() : false;
   const statusInfo = getStatusInfo(certificate.certificateStatus, isExpired);

   const formatDate = (timestamp) => {
      if (!timestamp) return null;
      return format(new Date(parseInt(timestamp)), 'MMMM d, yyyy');
   };

   // Handle cases where ptprCertificateData might be undefined
   const certificateData = certificate.ptprCertificateData || {};

   return (
      <div className="space-y-6">
         <div className="text-center mb-8">
            <statusInfo.icon className="mx-auto h-12 w-12 text-gray-600" />
            <h2 className="mt-4 text-3xl font-bold text-gray-900">
               Private Tree Plantation Registration Verification
            </h2>
         </div>

         <Card className="p-6 mb-6">
            <div className="flex justify-between items-center mb-6">
               <h3 className="text-lg font-semibold">Certificate Status</h3>
               <Badge className={statusInfo.color}>
                  {statusInfo.label}
               </Badge>
            </div>

            <div className="space-y-4">
               <div>
                  <h4 className="text-sm font-medium text-gray-500">Certificate Number</h4>
                  <p className="text-lg">{certificate.certificateNumber}</p>
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Owner Information</h4>
                  <p className="text-lg">{certificateData.ownerName}</p>
                  <p className="text-gray-600">{certificateData.address}</p>
                  <p className="text-gray-600">Contact: {certificateData.contactNumber}</p>
                  <p className="text-gray-600">Email: {certificateData.email}</p>
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Property Details</h4>
                  <p><span className="font-medium">OCT/TCT Number:</span> {certificateData.octTctNumber}</p>
                  <p><span className="font-medium">Lot Number:</span> {certificateData.lotNumber}</p>
                  <p><span className="font-medium">Location:</span> {certificateData.barangay}, {certificateData.municipality}, {certificateData.province}</p>
                  <p><span className="font-medium">Total Lot Area:</span> {certificateData.totalLotArea}</p>
                  <p><span className="font-medium">Area for Plantation:</span> {certificateData.areaDevotedToPlantation}</p>
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Plantation Details</h4>
                  <p><span className="font-medium">Tree Species:</span> {certificateData.treeSpeciesPlanted}</p>
                  <p><span className="font-medium">Spacing:</span> {certificateData.spacing}</p>
                  <p><span className="font-medium">Date Planted:</span> {formatDate(certificateData.datePlanted)}</p>
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Validity Period</h4>
                  <p><span className="font-medium">Issue Date:</span> {formatDate(certificate.dateIssued)}</p>
                  <p><span className="font-medium">Expiry Date:</span> {formatDate(certificate.expiryDate)}</p>
               </div>
            </div>
         </Card>
      </div>
   );
};

export default PTPRCertificateVerification;
